export const applicationApplicationTestProgramTemplateInject = Symbol.for('applicationApplicationTestProgramTemplate');
export const applicationReportTemplateInject = Symbol.for('applicationReportTemplateInject');
export const applicationApplicationProtocolTemplateInject = Symbol.for('applicationApplicationProtocolTemplate');
